import type { NoteCategory } from "../../types/lead.types.ts"

interface NoteCategoryColor {
  background: string
  border: string
  /** WCAG-legible label color in the same hue — the pastel `border` tone is
   *  too light to use as text. */
  text: string
}

/**
 * Six distinct, very-soft pastels — one per `NoteCategory`, derived, never
 * user-chosen, so editing a note's category visibly recolors its card.
 * `NoteCard` and `NotesListView`'s category chip both import this same map.
 */
const NOTE_CATEGORY_COLORS: Record<NoteCategory, NoteCategoryColor> = {
  general: { background: "#FEFCE8", border: "#FDE68A", text: "#92400E" }, // soft yellow
  customer: { background: "#EFF6FF", border: "#BFDBFE", text: "#1D4ED8" }, // soft blue
  follow_up: { background: "#FDF2F8", border: "#FBCFE8", text: "#BE185D" }, // soft pink
  proposal: { background: "#F0FDF4", border: "#BBF7D0", text: "#15803D" }, // soft green
  opportunity: { background: "#F5F3FF", border: "#DDD6FE", text: "#6D28D9" }, // soft lavender
  internal: { background: "#FFF7ED", border: "#FED7AA", text: "#C2410C" } // soft peach
}

export { type NoteCategoryColor, NOTE_CATEGORY_COLORS }
